import { Link } from "react-router-dom";
import Seo from "@/components/feature/Seo";

const values = [
  {
    icon: "ri-compass-3-line",
    title: "把脉络讲清楚",
    desc: "不满足于复述剧情，而是把宗门篇的发展脉络、境界体系与主线走向系统梳理，让读者一眼看懂全局。",
  },
  {
    icon: "ri-eye-2-line",
    title: "把细节挖出来",
    desc: "重视每一个容易被忽略的伏笔与细节，从旧章回看新篇，还原作者埋在字里行间的用心。",
  },
  {
    icon: "ri-group-line",
    title: "把同好聚起来",
    desc: "创造一个开放、友善的讨论氛围，让追更不再孤单，不同视角的碰撞才能拼出更完整的剧情。",
  },
];

const principles = [
  "内容以剧情讨论与信息梳理为主，坚持原创分析，不照搬原文。",
  "涉及剧透会先给阅读提示，保护还没补到进度的读者。",
  "不提供任何非官方资源，追踪更请认准漫画官方连载平台。",
  "接受同好投稿，尊重每一位作者的署名与劳动成果。",
];

export default function About() {
  return (
    <>
      <Seo
        title="关于我们 · 师兄啊师兄剧情讨论区"
        description="师兄啊师兄讨论区：专注《师兄啊师兄》漫画的宗门篇剧情梳理、修炼境界体系解读与主线伏笔盘点，以清晰与友善的态度服务每一位追更同好。"
        keywords="师兄啊师兄讨论区,关于我们,师兄啊师兄剧情讨论,师兄啊师兄宗门篇分析"
        type="website"
        path="/about"
      />

      <section className="border-b border-background-200 bg-background-100/60 py-12 md:py-16">
        <div className="container-x">
          <nav className="flex items-center gap-1.5 text-xs text-foreground-400" aria-label="面包屑">
            <Link to="/" className="hover:text-primary-600">
              首页
            </Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-600">关于我们</span>
          </nav>
          <h1 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">关于这个讨论区</h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600">
            这里是一群热爱《师兄啊师兄》的同好，自发建起的剧情讨论小站。我们把宗门篇的脉络、修炼境界的体系和主线的伏笔一点点整理成文，希望每一个追更的人都能看得更明白、聊得更尽兴。
          </p>
        </div>
      </section>

      <section className="container-x grid grid-cols-1 gap-10 py-12 md:py-16 lg:grid-cols-2 lg:items-center">
        <div className="overflow-hidden rounded-xl border border-background-200/70">
          <div className="aspect-[4/3] w-full">
            <img
              src="https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20of%20a%20scholar%20writing%20at%20a%20wooden%20desk%20under%20a%20pine%20tree%20with%20tea%20and%20scrolls%2C%20warm%20cream%20background%2C%20hand%20drawn%20brush%20strokes%2C%20serene%20traditional%20xianxia%20study%20atmosphere%2C%20soft%20warm%20light%2C%20elegant%20composition&width=1000&height=750&seq=about-sxs-scholar&orientation=landscape"
              alt="讨论区创立初衷水墨图：松下的写字者"
              className="h-full w-full object-cover"
            />
          </div>
        </div>
        <div>
          <p className="text-xs font-medium tracking-widest text-primary-600">我们的定位</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">一处专注剧情的同好驿站</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            我们无意成为资料站，也不做资源搬运。这里的核心，是把宗门篇如何展开、境界体系如何运转、主线如何一步步推进这些"门道"讲清楚，再交给同好们自由讨论。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            从入门扎根的日常，到内乱抉择的转折，我们对每一条脉络都尽可能保持客观与耐心，力求让新读者和老读者都能有所收获。
          </p>
        </div>
      </section>

      <section className="border-y border-background-200 bg-background-100/60 py-12 md:py-16">
        <div className="container-x">
          <div className="mx-auto max-w-2xl text-center">
            <p className="text-xs font-medium tracking-widest text-primary-600">发展理念</p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">我们坚持的三件事</h2>
          </div>
          <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
            {values.map((v) => (
              <div key={v.title} className="rounded-xl border border-background-200/70 bg-background-50 p-6 shadow-soft">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-50 text-2xl text-primary-600">
                  <i className={v.icon}></i>
                </span>
                <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-950">{v.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="container-x grid grid-cols-1 gap-10 py-12 md:py-16 lg:grid-cols-2">
        <div>
          <p className="text-xs font-medium tracking-widest text-primary-600">内容原则</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">我们怎么写内容</h2>
          <ul className="mt-6 space-y-4">
            {principles.map((p, i) => (
              <li key={i} className="flex items-start gap-3">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-100 text-xs font-medium text-accent-700">
                  {i + 1}
                </span>
                <span className="text-sm leading-relaxed text-foreground-600">{p}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="flex flex-col justify-center rounded-xl border border-background-200/70 bg-background-100/60 p-6 md:p-8">
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">联系方式</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            投稿剧情分析、反馈建议或单纯想聊聊剧情，欢迎通过留言表单或邮箱联系我们。
          </p>
          <ul className="mt-5 space-y-3 text-sm text-foreground-600">
            <li className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-50 text-primary-600">
                <i className="ri-mail-line"></i>
              </span>
              投稿邮箱：hello@example.com
            </li>
            <li className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-50 text-accent-600">
                <i className="ri-chat-3-line"></i>
              </span>
              留言讨论：通过本站留言表单
            </li>
          </ul>
          <Link
            to="/contact"
            className="mt-6 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:self-start"
          >
            <i className="ri-chat-3-line"></i>
            去留言讨论
          </Link>
        </div>
      </section>
    </>
  );
}